import { render, staticRenderFns } from "./scanforgetonShape2.vue?vue&type=template&id=50419872&scoped=true"
import script from "./scanforgetonShape2.vue?vue&type=script&lang=ts"
export * from "./scanforgetonShape2.vue?vue&type=script&lang=ts"
import style0 from "./scanforgetonShape2.vue?vue&type=style&index=0&id=50419872&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50419872",
  null
  
)

export default component.exports